export const iconFontAwesomeTextformattingTextHeight = (
	<i className="fa-solid fa-text-height"></i>
);
